import {SpecificAnswers} from '../models/specific-questions';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarsService {

  constructor(private http: HttpClient) {
  }

  public getCarMakes(): Observable<SpecificAnswers[]> {
    return this.http.get<SpecificAnswers[]>(`${environment.apiUrl}/api/Cars/makes`).pipe(
      map((response: any[]) => response.map(x => new SpecificAnswers(x)))
    );
  }

  public getCarYears(makeId: number): Observable<SpecificAnswers[]> {
    return this.http.get<SpecificAnswers[]>(`${environment.apiUrl}/api/Cars/years?makeId=${makeId}`).pipe(
      map((response: any[]) => response.map(x => new SpecificAnswers(x)))
    );
  }

  public getCarModels(makeId: number, year: number): Observable<SpecificAnswers[]> {
    return this.http.get<SpecificAnswers[]>(`${environment.apiUrl}/api/Cars/models?makeId=${makeId}&year=${year}`).pipe(
      map((response: any[]) => response.map(x => new SpecificAnswers(x)))
    );
  }

  public getCarTrims(makeId: number, year: number, modelId: number): Observable<SpecificAnswers[]> {
    return this.http.get<SpecificAnswers[]>(`${environment.apiUrl}/api/Cars/trims?makeId=${makeId}&year=${year}&modelId=${modelId}`)
      .pipe(map((response: any[]) => response.map(x => new SpecificAnswers(x))));
  }
}
